import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass der Clone-Button erst lädt, wenn der Sidebar-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'project-cloning',
  name: 'Projekt-Cloning',
  description:
    'Klont ein bestehendes Projekt als neuen Entwurf — Kunde und alle Brandschutz-Felder werden uebernommen.',
  category: 'data',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_CREATE],
  enabledByDefault: true,
};

const CloneButton = lazy(() => import('./CloneButton').then((m) => ({ default: m.CloneButton })));

export const projectCloningSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.sidebar': [
      {
        key: 'clone-button',
        // Block „selten" der Projekt-Sidebar (order ≥ 71, s. ProjectDetailPage):
        // Klonen ist eine einmalige Aktion, kein täglicher Arbeitsschritt.
        order: 80,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId, customerId, readOnly
        render: CloneButton,
      },
    ],
  },
};
